
import { Options, Vue } from 'vue-class-component';
import { mapState, mapMutations } from 'vuex';
// Components
import Alternative from '@/components/quiz/Alternative.vue';
// Types
import {
  Question as QuestionType,
  Alternative as AlternativeType,
} from '@/types/quiz.d';

@Options({
  props: {
    question: {
      type: Object,
    },
    total: {
      type: Number,
    },
  },
  watch: {
    alternativeSelected(value: AlternativeType) {
      if (!value.id) {
        this.disableNext = true;
      } else {
        this.disableNext = false;
      }
    },
  },
  computed: mapState(['alternativeSelected']),
  methods: mapMutations([
    'UPDATE_ALTERNATIVE_SELECTED',
    'UPDATE_PERCENT_QUIZ',
    'ADD_ANSWER_QUIZ',
  ]),
  components: {
    Alternative,
  },
})
export default class Question extends Vue {
  question!: QuestionType;

  total!: number;

  alternativeSelected!: AlternativeType;

  disableNext = true;

  UPDATE_ALTERNATIVE_SELECTED!: (status: AlternativeType | null) => void;

  UPDATE_PERCENT_QUIZ!: (percernt: number) => void;

  ADD_ANSWER_QUIZ!: (answerar: AlternativeType) => void;

  nextQuestion(): void {
    // update the percent
    const percent = Number(
      ((Number(this.question.id) / this.total) * 100).toFixed(1),
    );
    this.UPDATE_PERCENT_QUIZ(percent);

    const alternativeVoid: AlternativeType = {
      id: '',
      alternative: '',
    };
    this.$emit('next', this.question.id);
    // send alternative
    this.ADD_ANSWER_QUIZ(this.alternativeSelected);
    // clean the alternatives
    this.UPDATE_ALTERNATIVE_SELECTED(alternativeVoid);
  }
}
